<template>
  <div class="home" v-loading="loading">
    <!-- 轮播图 -->
    <div class="recommendPage">
      <swiper :options="swiperOptions" ref="mySwipers">
        <swiper-slide>
          <div class="bgImg" style="width: 100%; height: 50vh">
            <img
              style="width: 100%; height: 100%; position: relative"
              src="../assets/img/anlunbg01.jpg"
            />
          </div>
        </swiper-slide>
        <swiper-slide
          ><div class="bgImg" style="width: 100%; height: 50vh">
            <img
              style="width: 100%; height: 100%; position: relative"
              src="../assets/img/yfzx01.jpg"
            /></div
        ></swiper-slide>
        <swiper-slide
          ><div class="bgImg" style="width: 100%; height: 50vh">
            <img
              style="width: 100%; height: 100%; position: relative"
              src="../assets/img/bg3301.jpg"
            /></div
        ></swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>
    </div>
    <!-- 文字介绍 -->
    <div
      class="
        product
        container-fluid
        cst_sectionBlock cst_BGtransparent
        c-section
      "
    >
      <div class="cst-sectionBGwrap c-div">
        <div
          class="cst_sectionBG"
          style="background-image: ('../assets/img/second.jpg')"
        ></div>
      </div>
      <div class="container cst_container_base">
        <div class="cst_cardList_grid_icon">
          <div class="cst_grid">
            <div class="row cst_textSetting">
              <div class="c-inline-column col-lg-3 col-md-3 col-ms-3 col-xs-6">
                <div class="cst_block_item">
                  <!-- <div class="c-div">
                    <h2 class="counter c-heading">
                      <animate-number from="0" to="6"></animate-number>
                    </h2>
                  </div> -->
                  <h4 style="padding-top: 20px">{{this.$root.language == 1?'公司介绍':'Company Profile'}}</h4>
                  <p v-if="this.$root.language == 1" class="cst_description">
                    山西安仑化工有限公司是阳光集团控股子公司，位于山西省运城市河津市僧楼镇河津经济技术开发区东区（华泰西路以东，稷西路以北），是以煤焦油深加工、炭黑生产为主的新能源新材料工业企业。公司于2016年3月份成立，2017年9月份完成重组。公司占地400余亩，现有员工400余人,并设有炭黑研发中心及上海炭黑销售公司。
                  </p>
                  <p v-if="this.$root.language != 1" class="cst_description">
                    Shanxi Anlun Chemical Co., Ltd. is a subsidiary of Sunshine Group, located in the eastern area of Hejin Economic and Technological Development Zone, Senglou Town, Hejin City, Yuncheng City, Shanxi Province (east of Huatai West Road and north of Jixi Road). It is a new energy and new material industrial enterprise mainly engaged in coal tar deep processing and carbon black production. The company was established in March 2016 and completed its restructuring in September 2017. The company covers an area of over 400 acres and currently has more than 400 employees. It also has a carbon black research and development center and a Shanghai carbon black sales company.                  </p>
                </div>
              </div>
              <div class="c-inline-column col-lg-3 col-md-3 col-ms-3 col-xs-6">
                <div class="cst_block_item">
                  <!-- <div class="c-div">
                    <h2 class="counter c-heading"><animate-number from="0" to="24"></animate-number></h2>
                  </div> -->
                  <h4 style="padding-top: 20px">{{this.$root.language == 1?'主营产品':'Product line'}}</h4>
                  <p v-if="this.$root.language == 1" class="cst_description">
                    炭黑，是烃类物质（碳氢化合物及其衍生物）不完全燃烧或裂解生成的，主要由碳元素组成，以近似于球状的胶体粒子及聚集体形式存在的物质。炭黑是橡胶等高分子材料最重要的补强和填充材料。得益于强大的技术能力、多样化的生产线和反应炉型，安仑化工可以供应全系列国标类炭黑产品及其他定制化产品如低多环芳烃产品等三十多个品种。
                  </p>
                  <p v-if="this.$root.language != 1" class="cst_description">
                    Carbon black is a substance produced by incomplete combustion or cracking of hydrocarbon material (hydrocarbons and their derivatives), which is mainly composed of carbon elements and exists in the form of spherical colloidal particles and aggregates.  Carbon black is the most important reinforcing and filling material for rubber and other polymer materials.  Thanks to its strong technical capabilities, diversified production lines and reactor types, Anlun can supply a full range of national standard carbon black products and other customized products, such as low polycyclic aromatic hydrocarbon products with over 30 varieties.
                  </p>
                </div>
              </div>
              <div class="c-inline-column col-lg-3 col-md-3 col-ms-3 col-xs-6">
                <div class="cst_block_item">
                  <!-- <div class="c-div">
                    <h2 class="counter c-heading"><animate-number from="0" to="91"></animate-number></h2>
                  </div> -->
                  <h4 style="padding-top: 20px">{{this.$root.language == 1?'技术研发':'Research & Development'}}</h4>
                  <p v-if="this.$root.language == 1" class="cst_description">
                    公司高度重视技术研发工作，2019年投入3,050万元在工厂成立技术研发中心，2021年被评为运城市企业技术研发中心。公司每年从产品销售收入中提取不少于3.5%的经费用于科技研发，分别在上海和山西建有独立的、高标准的实验室，按照ISO/IEC17025建立的炭黑实验室通过CNAS认证。公司高度重视校企业合作，与山西煤炭化学研究所、天津大学、青岛科技大学、中北大学等多家行业内知名高校建立稳定的合作关系。公司目前已获得国家授权专利26项，参编国家标准5项（3项已发布，2项编制中）。
                  </p>
                  <p v-if="this.$root.language != 1" class="cst_description">
                    The company puts high emphasis on research and development.  In 2019, 30.5 million yuan was invested to set up a R&D center in its manufacturing plant.  In2021, it was rated as the center for enterprise R&D for Yuncheng city.  The company invest more than 3.5% of its annual revenue on R&D and set up high standard laboratories in the plant and Shanghai.  The laboratories are set up in accordance to ISO/IES17025 standards and certified for CNAS.  The company also puts high emphasis on cooperations with universities such as Shanxi Institute of Coal Chemistry, Tianjin University, Qingdao University of Science & Technology, and Central North University.  The company owns 26 national authorized patents and participated in the preparation of 5 national standards (3 were issued with 2 pending).                   </p>
                </div>
              </div>
              <div class="c-inline-column col-lg-3 col-md-3 col-ms-3 col-xs-6">
                <div class="cst_block_item">
                  <!-- <div class="c-div">
                    <h2 class="counter c-heading"><animate-number from="0" to="21"></animate-number></h2>
                  </div> -->
                  <h4 style="padding-top: 20px">{{this.$root.language == 1?'市场地位':'Market Position'}}</h4>
                  <p v-if="this.$root.language == 1" class="cst_description">
                    安仑化工在河津建有全球最大单体产能工厂，国内市场占用率超过7%，是国内第三大炭黑供应商。在服务于国内客户的同时，积极开拓国际客户，外贸占比超过10%。安仑化工以其稳定的产品质量和强大的保供能力赢得广大轮胎客户的信任。公司的非轮胎用炭黑目前已取得了较好的销售量，同时也在积极研发新产品，炭黑品种的丰富程度在国内炭黑企业中排名前列。
                  </p>
                  <p v-if="this.$root.language != 1" class="cst_description">
                    Anlun has the largest single capacity plant of the world with domestic market share of 7%.  It’s also the third largest carbon black supplier in China.  While servicing domestic customers in China, the company also actively pursuit international customers with export accounting for over 10% of its total revenue.  With its stable product quality and supply capability, Anlun won over the trust of many tire customers.  As for the non-tire market, Anlun has achieved substantial sales volume and is actively developing new products.  With the variety of many carbon black products, Anlun is in the top ranking among domestic suppliers.                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 企业文化 -->
    <div style="height: 100px"></div>
    <div
      class="fixedBg"
      style="
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: auto;
      "
    >
      <div
        style="
          display: flex;
          flex-direction: column;
          justify-content: center;
          width: 100%;
        "
      >
        <div
          style="
            margin: auto;
            width: 70%;
            display: flex;
            flex-direction: column;
            justify-content: center;
          "
        >
          <el-row>
            <el-col :span="8">
              <div
                style="
                  display: flex;
                  flex-direction: column;
                  justify-content: center;
                "
              >
                <a style="font-size: 40px; color: white; text-align: center"
                  >{{this.$root.language == 1?'企业使命':'Market Position'}}</a
                >
                <a
                  style="
                    margin-top: 10px;
                    margin-bottom: 20px;
                    font-size: 30px;
                    color: white; text-align: center
                  "
                  >{{this.$root.language == 1?'引领碳材料，造福全人类':'Be the leader in carbon materials for the benefit of mankind'}}</a
                >
              </div>
            </el-col>
            <el-col :span="8"
              ><div style="margin: 0; margin: 0 50px">
                <p style="font-size: 40px; color: white; text-align: center">
                  {{this.$root.language == 1?'企业愿景':'Enterprise Vision'}}
                </p>
                <p
                  style="
                    font-size: 24px;
                    color: white;
                    line-height: 36px;
                    text-align: center;
                  "
                >
                  {{this.$root.language == 1?'激情工作，快乐生活':'Working enthusiastically, living joyfully'}}

                </p>
                <p
                  style="
                    font-size: 24px;
                    color: white;
                    line-height: 36px;
                    text-align: center;
                  "
                >
                  {{this.$root.language == 1?'引领行业发展，为客户提供最佳解决方案':'Be the leader in industry development,Provide perfect solutions for customers'}}
                </p>
                <p
                  style="
                    font-size: 24px;
                    color: white;
                    line-height: 36px;
                    text-align: center;
                  "
                >
                  {{this.$root.language == 1?'安仑值得信赖！':'Anlun is trustworthy'}}
                </p>
              </div></el-col
            >
            <el-col :span="8"
              ><div style="margin: 0; margin: 0 50px">
                <p style="font-size: 40px; color: white; text-align: center">
                  {{this.$root.language == 1?'核心价值观':'Anlun is trustworthy'}}
                </p>
                <p
                  style="
                    font-size: 24px;
                    color: white;
                    line-height: 36px;
                    text-align: center;
                  "
                >
                  {{this.$root.language == 1?'聚焦客户&nbsp;&nbsp;&nbsp;&nbsp;合作共赢':'Focus on customers, cooperation for win/win'}}
                </p>
                <p
                  style="
                    font-size: 24px;
                    color: white;
                    line-height: 36px;
                    text-align: center;
                  "
                >
                  {{this.$root.language == 1?'关爱员工&nbsp;&nbsp;&nbsp;&nbsp;拥抱改变':'Care for employees, embrace changes'}}
                </p>
                <p
                  style="
                    font-size: 24px;
                    color: white;
                    line-height: 36px;
                    text-align: center;
                  "
                >
                  {{this.$root.language == 1?'诚实守信&nbsp;&nbsp;&nbsp;&nbsp;勇于担当':'Honesty, keep promises, dare to be responsible'}}
                </p>
                <p
                  style="
                    font-size: 24px;
                    color: white;
                    line-height: 36px;
                    text-align: center;
                  "
                >
                  {{this.$root.language == 1?'持续改善&nbsp;&nbsp;&nbsp;&nbsp;追求卓越':'Continuous improvement, pursuit excellence'}}
                </p>
              </div></el-col
            >
          </el-row>
          <!-- <div
            style="
              display: flex;
              flex-direction: column;
              justify-content: center;
            "
          >
            <a style="font-size: 55px; color: white">企业使命</a>
            <a
              style="
                margin-top: 10px;
                margin-bottom: 20px;
                font-size: 30px;
                color: white;
              "
              >引领碳材料，造福全人类</a
            >
          </div>
          <div style=" margin: 0; width: 50%">
            <a style="font-size: 55px; color: white">核心价值观</a>
            <p style="font-size: 24px; color: white; line-height: 36px">
              激情工作，快乐生活。引领行业发展，为客户提供最佳解决方案。安仑值得信赖！
            </p>
          </div>
          <div style="margin: 0; width: 70%">
            <a style="font-size: 55px; color: white">企业愿景</a>
            <p style="font-size: 24px; color: white; line-height: 36px">
              聚焦客户 合作共赢 关爱员工 拥抱改变 诚实守信 勇于担当 持续改善 追求卓越
            </p>
          </div> -->
          <div style="margin: auto"></div>
        </div>
      </div>
    </div>
    <div style="height: 50px"></div>

    <!-- 实验室风采 -->
    <!-- <div class="laboratory">
        <h2 style="text-align: center; font-weight: bold;padding-bottom: 50px;">实验风采</h2>
        <div class="laboratory">
          <div class="wrap" style="width: 60%;margin: 30px auto 50px;">
            <p style="text-indent: 2em;">公司高度重视技术研发工作，2019年投入3,050万元在工厂成立技术中心，2021年被评为运城市企业技术中心。研发中心现有科研人员91人，内部高级专家5名，博士1名，硕士6名。公司每年从产品销售收入中提取不少于3.5%的经费用于科技研发，分别在上海和山西建有独立的、高标准的实验室，按照ISO/IEC17025建立的炭黑实验室通过CNAS认证。公司高度重视校企业合作，与山西煤炭化学研究所、天津大学、青岛科技大学、中北大学等多家行业内知名高校建立稳定的合作关系。公司目前已获得国家授权专利26项，参编国家标准5项。</p>
          </div>
        </div>
        <div class="lab_wrap">
            <el-carousel :interval="3000" type="card" style="height: 400px; width:60%; margin: 0 auto;">
                <el-carousel-item v-for="(item, index) in labList" :key="index" style="background-color: #fff;">
                    <div class="wrap_left" style="width: 100%;height: 100%;">
                        <img style="width: 100%; height: 100%;" :src="item.img" />
                    </div>
                </el-carousel-item>
            </el-carousel>
        </div>
    </div> -->

    <!-- 合作伙伴名单 -->
    <!-- <div class="partner">
      <div class="partner_wrap">
        <h2 style="font-weight: bold;">合作伙伴</h2>
        <img class="partnerImg" src="../assets/img/customer.png" />
      </div>
    </div> -->
    <!-- 合作伙伴中国地图 -->
    <div
      class="content"
      id="content"
      style="z-index: 1; width: 100%; height: 600px; display: none"
    ></div>
    <!-- 安仑地图位置 -->
    <div
      class="anlunAMap"
      id="mapChart"
      :style="{ width: '90%', height: '400px',margin: '0 auto 50px' }"
    >
      <div id="container" class="map"></div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  name: "testHome",
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      loading: false,
      center: [110.75, 35.69],
      map: null,
      zoom: 18,
      labList: [
        {
          id: 1,
          img: require("../assets/img/yf1.jpg"),
          content:
            "公司高度重视技术研发工作，2019年投入3,050万元在工厂成立技术中心，2021年被评为运城市企业技术中心。研发中心现有科研人员91人，内部高级专家5名，博士1名，硕士6名。公司每年从产品销售收入中提取不少于3.5%的经费用于科技研发，分别在上海和山西建有独立的、高标准的实验室，按照ISO/IEC17025建立的炭黑实验室通过CNAS认证。",
        },
        {
          id: 2,
          img: require("../assets/img/yf3.jpg"),
          content:
            "安仑化工拥有以下5大核心竞争力，更好地满足日益增长的客户需要1. 稳定可靠的原料供应能力2. 原料油深加工是定制化产品的基础3. 定制化产品满足客户日益增长的应用需求4. 灵活的仓储、包装和运输能力5. 五项服务助力客户发展。",
        },
        {
          id: 3,
          img: require("../assets/img/yf4.jpg"),
          content:
            "公司高度重视校企业合作，与山西煤炭化学研究所、天津大学、青岛科技大学、中北大学等多家行业内知名高校建立稳定的合作关系。公司目前已获得国家授权专利26项，参编国家标准5项。安仑化工现已形成5大产品系列1. 高性能轮胎用胎面炭黑2. 工业橡胶制品用高洁净炭黑3. 色母粒用中高色素洁净炭黑4. 液体应用低中高色素炭黑5. 环保系列产品。",
        },
      ],
      swiperOptions: {
        loop: true,
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        // 显示分页
        pagination: {
          el: ".swiper-pagination",
          clickable: true, //允许分页点击跳转
        },
        // 设置点击箭头
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    };
  },
  methods: {
    initMapInfo() {
      // 地图数据
      var chinaGeoCoordMap = {
        黑龙江: [127.9688, 45.368],
        内蒙古: [110.3467, 41.4899],
        吉林: [125.8154, 44.2584],
        北京市: [116.4551, 40.2539],
        辽宁: [123.1238, 42.1216],
        河北: [114.4995, 38.1006],
        天津: [117.4219, 39.4189],
        山西: [112.3352, 37.9413],
        陕西: [109.1162, 34.2004],
        甘肃: [103.5901, 36.3043],
        宁夏: [106.3586, 38.1775],
        青海: [101.4038, 36.8207],
        新疆: [87.9236, 43.5883],
        西藏: [91.11, 29.97],
        四川: [103.9526, 30.7617],
        重庆: [108.384366, 30.439702],
        山东: [117.1582, 36.8701],
        河南: [113.4668, 34.6234],
        江苏: [118.8062, 31.9208],
        安徽: [117.29, 32.0581],
        湖北: [114.3896, 30.6628],
        浙江: [119.5313, 29.8773],
        福建: [119.4543, 25.9222],
        江西: [116.0046, 28.6633],
        湖南: [113.0823, 28.2568],
        贵州: [106.6992, 26.7682],
        云南: [102.9199, 25.4663],
        广东: [113.12244, 23.009505],
        广西: [108.479, 23.1152],
        海南: [110.3893, 19.8516],
        上海: [121.4648, 31.2891],
        运城: [110.98, 35.02],
      };
      // 飞线点数据
      var chinaDatas = [
        [
          {
            name: "黑龙江",
            value: 10,
          },
        ],
        [
          {
            name: "内蒙古",
            value: 20,
          },
        ],
        [
          {
            name: "吉林",
            value: 30,
          },
        ],
        [
          {
            name: "辽宁",
            value: 0,
          },
        ],
        [
          {
            name: "河北",
            value: 0,
          },
        ],
        [
          {
            name: "天津",
            value: 0,
          },
        ],
        [
          {
            name: "山西",
            value: 0,
          },
        ],
        [
          {
            name: "陕西",
            value: 0,
          },
        ],
        [
          {
            name: "甘肃",
            value: 0,
          },
        ],
        [
          {
            name: "宁夏",
            value: 0,
          },
        ],
        [
          {
            name: "青海",
            value: 0,
          },
        ],
        [
          {
            name: "新疆",
            value: 0,
          },
        ],
        [
          {
            name: "西藏",
            value: 0,
          },
        ],
        [
          {
            name: "四川",
            value: 0,
          },
        ],
        [
          {
            name: "山东",
            value: 0,
          },
        ],
        [
          {
            name: "河南",
            value: 0,
          },
        ],
        [
          {
            name: "江苏",
            value: 0,
          },
        ],
        [
          {
            name: "安徽",
            value: 0,
          },
        ],
        [
          {
            name: "湖北",
            value: 0,
          },
        ],
        [
          {
            name: "浙江",
            value: 0,
          },
        ],
        [
          {
            name: "福建",
            value: 0,
          },
        ],
        [
          {
            name: "江西",
            value: 0,
          },
        ],
        [
          {
            name: "湖南",
            value: 0,
          },
        ],
        [
          {
            name: "贵州",
            value: 0,
          },
        ],
        [
          {
            name: "广西",
            value: 0,
          },
        ],
        [
          {
            name: "海南",
            value: 0,
          },
        ],
        [
          {
            name: "上海",
            value: 1,
          },
        ],
      ];

      let formdata = "运城"; // 中心点

      var convertData = function (data) {
        var res = [];
        for (var i = 0; i < data.length; i++) {
          var dataItem = data[i];
          var fromCoord = chinaGeoCoordMap[dataItem[0].name];
          var toCoord = [110.98, 35.02]; //中心点地理坐标
          if (fromCoord && toCoord) {
            res.push([
              {
                // 飞线从哪里出发
                coord: toCoord,
              },
              {
                // 飞线去往哪里
                coord: fromCoord,
                value: dataItem[0].value,
              },
            ]);
          }
        }
        return res;
      };
      var series = [];
      [[formdata, chinaDatas]].forEach(function (item, i) {
        series.push(
          {
            type: "lines",
            coordinateSystem: "geo",
            zlevel: 2,
            effect: {
              show: true,
              period: 4, //箭头指向速度，值越小速度越快
              trailLength: 0, //特效尾迹长度[0,1]值越大，尾迹越长重
              symbol: "arrow", //箭头图标
              symbolSize: 5, //图标大小
              color: "#fcdd6e", // 图标颜色
            },
            lineStyle: {
              normal: {
                show: true,
                width: 1, //尾迹线条宽度
                opacity: 1, //尾迹线条透明度
                curveness: 0.3, //尾迹线条曲直度
                color: "#fcdd6e", // 飞线颜色
              },
              color: "#fcdd6e",
            },
            data: convertData(item[1]),
          },
          {
            type: "effectScatter",
            coordinateSystem: "geo",
            zlevel: 2,
            rippleEffect: {
              //涟漪特效
              period: 4, //动画时间，值越小速度越快
              brushType: "stroke", //波纹绘制方式 stroke, fill
              scale: 3, //波纹圆环最大限制，值越大波纹越大
              color: "#fcdd6e",
            },
            label: {
              normal: {
                show: false,
                position: "right", //显示位置
                offset: [5, 0], //偏移设置
                formatter: function (params) {
                  //圆环显示文字
                  return params.data.name;
                },
                fontSize: 13,
              },
              emphasis: {
                show: false,
              },
            },
            symbol: "circle",
            symbolSize: function (val) {
              return 5; //圆环大小
            },
            itemStyle: {
              normal: {
                show: false,
                color: "#fce182",
              },
            },
            data: item[1].map(function (dataItem) {
              return {
                //在这里定义你所要展示的数据
                // name: dataItem[0].name,
                // value: chinaGeoCoordMap[dataItem[0].name].concat([dataItem[0].value]),
                name: dataItem[0].name,
                value: chinaGeoCoordMap[dataItem[0].name].concat([
                  dataItem[0].value,
                ]),
              };
            }),
          },
          //中心点
          {
            type: "effectScatter",
            coordinateSystem: "geo",
            zlevel: 15,
            rippleEffect: {
              period: 4,
              brushType: "stroke",
              scale: 4,
              color: "#38ff85",
            },
            label: {
              normal: {
                show: false,
                position: "right",
                //offset:[5, 0],
                color: "#38ff85",
                formatter: "{b}",
                textStyle: {
                  color: "#38ff85",
                },
              },
              emphasis: {
                show: false,
                color: "#38ff85",
              },
            },
            symbol: "circle",
            symbolSize: 5,
            itemStyle: {
              color: "#38ff85",
            },
            data: [
              {
                name: item[0],
                value: chinaGeoCoordMap[item[0]].concat([10]),
              },
            ],
          }
        );
      });
      this.initMap(series);
    },

    initMap(series) {
      const echarts = require("echarts");
      let myChart = echarts.init(document.getElementById("content"));
      let option = {
        title: {
          text: "客户分布",
          subtext: "全球优质客户",
          show: true,
          target: "blank",
          subtarget: "blank",
          left: "20%",
          top: 0,
          textStyle: {
            fontSize: 30,
            fontWeight: "bold",
            color: "#464646",
          },
          subtextStyle: {
            fontSize: 18,
            color: "#464646",
          },
        },
        // bgColor: '#1a1e45',
        tooltip: {
          trigger: "item",
          formatter: function (params) {
            console.log(params);
          },
        },
        legend: {
          orient: "horizontal", //图例的排列方向
          // textStyle: { color: '#1a1e45' },
          x: "left", //图例的位置
          y: "-20000000000000",
        },
        visualMap: {
          //颜色的设置  dataRange
          // textStyle: { color: '#1a1e45' },
          x: "left",
          y: "bottom",
          // splitList: [{ start: 0, end: 150000 }],
          show: false,
          // text:['高','低'],// 文本，默认为数值文本
          // color: ['#1a1e45'],
        },
        geo: {
          map: "china",
          zoom: 1.2,
          label: {
            normal: {
              show: false,
              textStyle: {
                color: "#FFFFFF",
              },
            },
            emphasis: {
              show: false,
            },
          },
          roam: false, //是否允许缩放
          itemStyle: {
            normal: {
              color: "#1a1e45", //地图背景色
              borderColor: "#22ccfb", //省市边界线00fcff 516a89
              borderWidth: 1,
              textStyle: "#fff",
            },
            emphasis: {
              color: "#22ccfb", //悬浮背景
            },
          },
          data: [],
        },
        series: series,
      };

      myChart.setOption(option);
    },
    createMap() {
      //创建地图
      var map = new window.AMap.Map("mapChart", {
        lang: 'zh_en',
        resizeEnable: true, //是否监控地图容器尺寸变化
        zoom: 15, //初始化地图层级
        center: [110.746,35.693], //初始化地图中心点
        zoomEnable: true,
        scrollWheel: true,
      });
      //添加标记
      var marker = new window.AMap.Marker({
        position: [110.746,35.693],
        offset: new window.AMap.Pixel(-13, -30),
      });
      marker.setMap(map);
    },
  },
  mounted() {
    this.$nextTick((_) => {
      this.initMapInfo();
      this.createMap();
    });
  },
};
</script>

<style lang="scss" scoped>
@media (min-width: 768px) {
  .container {
    width: 750px;
  }
}
@media (min-width: 992px) {
  .container {
    width: 970px;
  }
}
@media (min-width: 1200px) {
  .container {
    width: 1170px;
  }
}
.product {
  padding-top: 110px;
  padding-bottom: 100px;
  background: transparent !important;
  .container {
    position: relative;
    padding-top: 0px;
    padding-bottom: 0px;
    background-color: rgba(0, 0, 0, 0);
    padding-right: 15px;
    padding-left: 15px;
    margin-left: auto;
    margin-right: auto;
  }
  &::before {
    display: table;
    content: "";
  }
  .cst_cardList_grid_icon {
    background-color: rgba(0, 0, 0, 0);
    margin-bottom: 0px;
    margin-top: -20px;
    .cst_grid {
      padding: 0px;
      .cst_textSetting {
        padding-bottom: 0px;
        // border-bottom: 1px solid rgb(79,79,79);
        align-items: flex-start;
        flex-flow: row wrap;
        color: #434343;
        text-align: center;
        .c-inline-column {
          background-color: transparent;
          padding: 0px;
          text-align: center;
          float: none;
          display: inline-block;
          vertical-align: top;
          .cst_block_item {
            transform: rotate(0deg) scale(1) translate(0%, 0%);
            transition: all 0.3s ease;
            &:hover {
              box-shadow: rgba(0, 0, 0, 0.2) 0px 4px 10px 0px;
              transform: rotate(0deg) scale(1) translate(0%, -5%);
              transition: all 0.3s ease;
              z-index: 10;
            }
            .c-div {
              justify-content: center;
              padding: 20px 15px 10px;
              padding-right: 15px;
              min-height: 80px;
              h2 {
                margin-top: 0px;
                margin-bottom: 0px;
                font-family: Oswald;
                color: rgb(30, 120, 216);
              }
            }
            h2 {
              font-weight: normal;
              margin-bottom: 5px;
              padding-left: 15px;
              padding-right: 15px;
              min-width: 10px;
              min-height: 10px;
            }
            p {
              line-height: 1.7em;
              font-weight: 200;
              padding: 15px;
              margin-bottom: 0px;
              font-size: 13px;
              opacity: 0.8;
              text-align: left;
            }
          }
        }
      }
    }
  }
}
.cst_sectionBlock {
  position: relative;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;
}

.fixedBg {
  min-height: 600px;
  background-image: url("../assets/img/bg.jpg");
  background-position: center center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
}
.partner {
  width: 100%;
  height: 800px;
  .partner_wrap {
    width: 80%;
    height: 100%;
    margin: 0 auto;
    h2 {
      text-align: center;
      padding-bottom: 50px;
    }
    .partnerImg {
      width: 100%;
      height: 90%;
    }
  }
}
.content {
  margin: 200px 0;
}
</style>